<template>
  <div class="container">
    <p>{{ t('computeYieldsBasedOnHarvestWeights') }}</p>
    <div class="row">
      <div class="col-sm">
        <!-- Inputs -->
        <GenericInput
          :input-label="t('minWetYieldPerPlant')"
          v-model.number="minOz"
          :conversion-factors="ConversionFactors.basicWeight"
        />
        <GenericInput
          :input-label="t('avgWetYieldPerPlant')"
          v-model.number="avgOz"
          :conversion-factors="ConversionFactors.basicWeight"
        />
        <GenericInput
          :input-label="t('maxWetYieldPerPlant')"
          v-model.number="maxOz"
          :conversion-factors="ConversionFactors.basicWeight"
        />
        <FixedUnitInput
          :input-label="t('plantCount')"
          v-model.number="plantCount"
          :unit="t('plants')"
        />
        <FixedUnitInput
          :input-label="t('dryingLoss')"
          v-model.number="dryingLossPercentage"
          :unit="t('percent')"
        />
      </div>
      <div class="col-sm">
        <!-- Outputs -->
        <GenericOutput
          :output-label="t('minYield')"
          :number="yields[0]"
          :conversion-factors="ConversionFactors.basicWeight"
          :showSplitter="false"
        />
        <GenericOutput
          :output-label="t('avgYield')"
          :number="yields[1]"
          :conversion-factors="ConversionFactors.basicWeight"
          :showSplitter="false"
        />
        <GenericOutput
          :output-label="t('maxYield')"
          :number="yields[2]"
          :conversion-factors="ConversionFactors.basicWeight"
          :showSplitter="false"
        />
      </div>
    </div>
    <i>{{ t('dryingLossNote') }}</i>
  </div>
</template>
  
  <script>
  import { ref, computed, reactive } from 'vue';
  import { useI18n } from 'vue-i18n';
  import GenericInput from '../inputs/GenericInput.vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import GenericOutput from '../inputs/GenericOutput.vue';
  import ConversionFactors from '../../utils/conversion_factors';
  
  export default {
    components: {
      GenericInput,
      FixedUnitInput,
      GenericOutput,
    },
    setup() {
      const minOz = ref(40);
      const avgOz = ref(55);
      const maxOz = ref(80);
      const plantCount = ref(10);
      const dryingLossPercentage = ref(65);

      const { t } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      });
  
      const yields = computed(() => {
        return [
          minOz.value * plantCount.value * (1 - dryingLossPercentage.value / 100),
          avgOz.value * plantCount.value * (1 - dryingLossPercentage.value / 100),
          maxOz.value * plantCount.value * (1 - dryingLossPercentage.value / 100),
        ];
      });
  
      return {
        minOz,
        avgOz,
        maxOz,
        plantCount,
        dryingLossPercentage,
        yields,
        ConversionFactors,
        t: translations.t,
      };
    },
  };
  </script>
  